export const name = 'gzCarousel';
export default function gzCarousel(
  // Directive angular dependencies
) {
  'ngInject';

  let directive = {
    restrict: 'EA',
    scope: {
      options: '=',
      id: '=',
      language: '=',
    },
    template: require('./carousel.jade'),
    link: carouselLink,
    controller: carouselController,
    controllerAs: 'vm',
    bindToController: true,
  };
  return directive;

  //////////////////////

  function carouselLink(scope, element, attrs) {
  }

  /** @ngInject */
  function carouselController(
    // Controller angular dependencies
    $window,
    $translate,
    $scope,
    $timeout,
    $gzAnalytics
  ) {
    // Constants
    const DEFAULT_DELAY = 7*1000;
    const SELECT_DELAY = 20*1000;

    // Variables
    let pageAdvanceTimer;
    let debounceResetTimer = _.debounce(() => { resetTimer(vm.timer); }, 200, {maxWait: 1000, trailing: true});
    let hasVideo = false;
    let isVideoPlaying = false;

    // View Model
    let vm = this;
    //   VM properties
    vm.index = 0;
    vm.visualAssets = [];
    vm.playerAPI = {};
    vm.imageClick = imageClick;

    //   VM methods
    vm.next = next;
    vm.previous = previous;
    vm.specify = specify;
    vm.handleMouseMove = handleMouseMove;

    vm.$onInit = onInit;
    return;

    ///////////////
    // Init
    function onInit() {
      vm.visualAssets = [];
      vm.options.api = {
        setPage: specify
      };
      vm.options.forEach(option => {
        switch(option.type) {
          case 'video':
            vm.visualAssets.push({
              type: 'video',
              ga: option.ga,
              id: option.videoIds[vm.language] ? option.videoIds[vm.language] : option.videoIds.en,
            });
            hasVideo = true;
            break;
          case 'image':
            vm.visualAssets.push({
              type: 'image',
              ga: option.ga,
              src: option.path.startsWith('https') ? option.path : 'https://cdn.printos.com/images/market/products/summary/' + $window.encodeURIComponent(option.path),
              message: option.message,
              messageKey: option.messageKey,
              link: option.link
            });
            break;
          case 'directive':
              vm.visualAssets.push({
                type: 'directive',
                name: option.name,
              });
            break;
          case 'testimonial':
            let myOptions = option.options;
            let opts = {};
            if (myOptions.logo) {
              opts.logo = myOptions.logo.startsWith('https') ? myOptions.logo : 'https://cdn.printos.com/images/market/products/summary/' + $window.encodeURIComponent(myOptions.logo);
            }
            if (myOptions.headline || myOptions.headlineKey) {
              opts.headline = myOptions.headlineKey ? $translate.instant(myOptions.headlineKey) : myOptions.headline;
            }
            opts.quote = myOptions.quoteKey ? $translate.instant(myOptions.quoteKey) : myOptions.quote;
            if (myOptions.picture) {
              opts.picture = myOptions.picture.startsWith('https') ? myOptions.picture : 'https://cdn.printos.com/images/market/products/summary/' + $window.encodeURIComponent(myOptions.picture);
            }
            opts.name = myOptions.name;
            opts.title = myOptions.title;
            opts.company = myOptions.company;
            opts.companyname = myOptions.companyname;
            opts.image1 = myOptions.image1;
            opts.image2 = myOptions.image2;
            opts.layout = myOptions.layout;
            opts.showVariant = myOptions.showVariant;
            opts.style = myOptions.style;
            vm.visualAssets.push({
              type: 'testimonial',
              options: opts,
            });
            break;
        }
      });

      if (vm.visualAssets.length > 1) {
        startTimer();
        $scope.$on('$destroy', () => {
          cancelTimer();
        });

        if (hasVideo) {
          $window.addEventListener('gz-youtube-play', handleVideoPlay);
          $window.addEventListener('gz-youtube-stop', handleVideoStop);
          $window.addEventListener('gz-youtube-pause', handleVideoStop);
        }
      }
    }

    ///////////////
    // VM methods
    function previous(userClick = false) {
      vm.index--;
      if (vm.index < 0) {
        vm.index = vm.visualAssets.length - 1;
      }

      if (userClick) {
        $gzAnalytics.event(`${vm.id} Carousel Navigation`, { type: 'previous'});
        $window.dispatchEvent(new window.CustomEvent('gz-youtube-command-stop', {detail: { playerId: 'gz-carousel' }} ));
        resetTimer(SELECT_DELAY);
      }
      else {
        resetTimer();
      }
    }

    function next(userClick = false) {
      vm.index++;
      if (vm.index > vm.visualAssets.length -1) {
        vm.index = 0;
      }

      if (userClick) {
        $gzAnalytics.event(`${vm.id} Carousel Navigation`, { type: 'next'});
        $window.dispatchEvent(new window.CustomEvent('gz-youtube-command-stop', {detail: { playerId: 'gz-carousel' }} ));
        resetTimer(SELECT_DELAY);
      }
      else {
        resetTimer();
      }
    }

    function specify(index) {
      vm.index = index;
      $gzAnalytics.event(`${vm.id} Carousel Navigation`, { type: 'index'});
      $window.dispatchEvent(new window.CustomEvent('gz-youtube-command-stop', {detail: { playerId: 'gz-carousel' }} ));
      resetTimer(SELECT_DELAY);
    }

    function handleMouseMove() {
      if (!isVideoPlaying) {
        debounceResetTimer();
      }
      else {
        cancelTimer();
      }
    }

    function handleVideoPlay(event) {
      $gzAnalytics.event(`${vm.id} Carousel Play Video`, { videoId: event.detail.videoId });
      isVideoPlaying = true;
      cancelTimer();
    }

    function handleVideoStop(event) {
      if (isVideoPlaying) {
        isVideoPlaying = false;
        startTimer();
      }
    }

    ///////////////
    // Helpers
    function startTimer(delay = DEFAULT_DELAY) {
      vm.timer = delay;
      if (!pageAdvanceTimer) {
        pageAdvanceTimer = $timeout(next, delay);
      }
    }

    function cancelTimer() {
      if (pageAdvanceTimer) {
        $timeout.cancel(pageAdvanceTimer);
        pageAdvanceTimer = null;
      }
    }

    function resetTimer(delay = DEFAULT_DELAY) {
      cancelTimer();
      startTimer(delay);
    }

    function imageClick(asset) {
      if (asset.link) {
        if (asset.ga) {
          $gzAnalytics.event(asset.ga.title, asset.ga.options);
        }
        window.open(asset.link, '_blank');
      }
    }
  }
}



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/carousel/carousel.directive.js